// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import resolutionImplementationTaskEntity from './entities/resolution-implementation-task.json';
import resolutionImplementationTaskMenu from '../pages/resolution-implementation-task/menu.json';
import resolutionImplementationTaskFullForm from '../pages/resolution-implementation-task/forms/full.json';
import resolutionImplementationTaskContextForm from '../pages/resolution-implementation-task/forms/context.json';
import resolutionImplementationTaskMiniForm from '../pages/resolution-implementation-task/forms/mini.json';
import resolutionImplementationTaskLookupForm from '../pages/resolution-implementation-task/forms/lookup.json';
import resolutionImplementationTaskTableView from '../pages/resolution-implementation-task/views/table.json';
import resolutionImplementationTaskCardsView from '../pages/resolution-implementation-task/views/cards.json';
import resolutionImplementationTaskCalendarView from '../pages/resolution-implementation-task/views/calendar.json';
import resolutionImplementationTaskDashboardView from '../pages/resolution-implementation-task/views/dashboard.json';

/** Тип запису «Завдання з виконання» зі сторінками пакета: меню, форми та подання з pages/resolution-implementation-task/. */
export const resolutionImplementationTaskDefinition: IRecordTypeDefinition = {
  ...resolutionImplementationTaskEntity,
  views: assembleViewSet({
      table: resolutionImplementationTaskTableView,
      cards: resolutionImplementationTaskCardsView,
      calendar: resolutionImplementationTaskCalendarView,
      dashboard: resolutionImplementationTaskDashboardView,
  }),
  form: resolutionImplementationTaskFullForm,
  forms: { full: resolutionImplementationTaskFullForm, context: resolutionImplementationTaskContextForm, mini: resolutionImplementationTaskMiniForm, lookup: resolutionImplementationTaskLookupForm },
  menu: resolutionImplementationTaskMenu,
} as IRecordTypeDefinition;
